import styled, { css } from 'styled-components';

import ArrowButton from 'Elements/Button/Arrow';

import { ReactComponent as WaveSVG } from 'Public/graphics/waves/open-days/tour.svg';

export const Container = styled.section`
    ${({ theme }) => css`
        position: relative;
        padding: 6rem 0 2rem;
        text-align: center;
        background: ${theme.colors.primaryContrast.hex};
        overflow: hidden;

        @media ${theme.breakpoints.medium.media} {
            padding: 3rem 0 4rem;
        }
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        margin: 0;
        font-size: 2rem;
        line-height: 1.25;
        font-weight: 700;
        text-transform: none;
        letter-spacing: normal;

        @media ${theme.breakpoints.large.media} {
            font-size: 3rem;
        }
    `}
`;

export const Description = styled.p`
    ${({ theme }) => css`
        margin: 0.75rem 0 0;
        font-size: 1.125rem;
        line-height: 1.5;

        @media ${theme.breakpoints.large.media} {
            margin: 1.25rem 0 0;
            font-size: 1.25rem;
        }
    `}
`;

export const StyledButton = styled(ArrowButton)`
    ${({ theme }) => css`
        margin-top: 1.5rem;

        @media ${theme.breakpoints.large.media} {
            margin-top: 3rem;
        }
    `}
`;

export const Wave = styled(WaveSVG)`
    ${({ theme }) => css`
        position: absolute;
        pointer-events: none;
        top: -20rem;
        left: -25rem;
        width: 51rem;
        height: 54rem;

        @media ${theme.breakpoints.medium.media} {
            transform: rotate(75deg) scale(-1);
            transform-origin: center;
            top: -31rem;
            left: -39rem;
            width: 110rem;
            height: 96rem;
        }

        @media ${theme.breakpoints.large.media} {
            top: -82rem;
            left: -150rem;
            width: 225rem;
            height: 150rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            top: -85rem;
            left: -143rem;
        }

        @media ${theme.breakpoints.huge.media} {
            top: -89rem;
        }
    `}
`;
